import * as React from 'react';
import {Content} from '../components/content';
import RotatingText from '../components/rotatingText';

class About extends React.Component {
  render() {
    return (<Content id="about">
        <h1>Hello 👋</h1>
        <p>I'm Lizzie (she/her), a Louisville, CO-based 
          <RotatingText
            items={[
              "software engineer 💻",
              "dog fanatic 🐶",
              "crocheter 🧶",
              "soccer player ⚽",
              "pianist 🎹",
              "marimba player",
              "curler 🥌",
              "runner 🏃‍♀️",
              "swimmer 🏊‍♀️",
            ]}
          />
        </p>
    </Content>)
  }
}

export default About;